module.exports = __webpack_public_path__ + "static/media/three.a3b31309.svg";